import { useDominanciaBloco } from "./use-dominancia-bloco";
import { DominanciaBlocoView } from "./view-dominancia-bloco";
import type { DominanciaBlocoProps } from "./types-dominancia-bloco";

export function DominanciaBloco(props: DominanciaBlocoProps) {
  const vm = useDominanciaBloco(props);

  return <DominanciaBlocoView {...props} {...vm} />;
}

export type * from "./types-dominancia-bloco";
